/**
 * Orientace fotky z jejích rozměrů — jediné místo pravidla (vize podnety-tymu-2026-10, F7.5:
 * filtr orientace na stránce Média). Filtr v SQL (`apps/api/src/lib/mediaLibraryQuery.ts`)
 * nese týž výraz `abs(width - height) <= 0.02 * max(width, height)`; obě strany čtou
 * `MEDIA_SQUARE_TOLERANCE`.
 *
 * Čtverec není jen `w === h`: fotka 1000×990 je pro redakci čtverec, ořez ji nezkreslí.
 */

export const MEDIA_ORIENTATIONS = ["landscape", "portrait", "square"] as const;
export type MediaOrientation = (typeof MEDIA_ORIENTATIONS)[number];

/** Podíl delší strany, do kterého je rozdíl stran ještě čtverec. */
export const MEDIA_SQUARE_TOLERANCE = 0.02;

export function mediaOrientation(width: number, height: number): MediaOrientation {
  if (Math.abs(width - height) <= MEDIA_SQUARE_TOLERANCE * Math.max(width, height)) {
    return "square";
  }
  return width > height ? "landscape" : "portrait";
}
